import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { RECOMMEND_MOBILITY_TOOL_LABELS } from '@/constant/review';
import BottomSheet from '@/modals/BottomSheet/BottomSheet';
const MOBILITY_TYPE_OPTIONS = [
    null, // 전체
    'MANUAL_WHEELCHAIR',
    'ELECTRIC_WHEELCHAIR',
    'STROLLER',
    'ELDERLY',
    'NONE',
];
export default function PlaceVisitReviewFilterModal({ isVisible, selected, onSelect, onClose, }) {
    return (_jsx(BottomSheet, { isVisible: isVisible, onPressBackground: onClose, children: _jsxs(ScrollView, { contentContainerStyle: {
                gap: 16,
                paddingVertical: 24,
                paddingHorizontal: 20,
            }, showsVerticalScrollIndicator: false, children: [_jsx(Title, { children: "\uCD94\uCC9C\uB300\uC0C1 \uC120\uD0DD" }), _jsx(OptionList, { children: MOBILITY_TYPE_OPTIONS.map(type => (_jsx(OptionButton, { elementName: "place_visit_review_filter_option", isActive: selected === type, onPress: () => {
                            onSelect(type);
                            onClose();
                        }, children: _jsx(OptionText, { isActive: selected === type, children: type === null ? '전체' : RECOMMEND_MOBILITY_TOOL_LABELS[type] }) }, type !== null && type !== void 0 ? type : 'ALL'))) })] }) }));
}
const Title = styled.Text `
  font-size: 18px;
  font-family: ${() => font.pretendardBold};
  color: ${color.gray100};
  margin-bottom: 12px;
`;
const OptionList = styled.View `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const OptionButton = styled(SccTouchableOpacity) `
  padding-vertical: 12px;
  padding-horizontal: 16px;
  border-radius: 8px;
  background-color: ${({ isActive }) => (isActive ? color.brand5 : color.white)};
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? color.brand : color.gray20)};
`;
const OptionText = styled.Text `
  font-size: 16px;
  font-family: ${() => font.pretendardMedium};
  color: ${({ isActive }) => (isActive ? color.brand50 : color.gray100)};
`;
